import React from 'react';
import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import Customer from './pages/customer';
import Routerboard from './pages/routerboard';
import Cekstatustoken from './cekStatusToken';
import detailCustomer from './pages/detailCustomer';
import ActiveConnection from './pages/activeConnection';
import Billing from './pages/billing';
import Pengaturan from './pages/components/pengaturan';
import Pppsecret from './pages/pppsecret';
import Scheduler from './pages/scheduler';
import { Container } from 'react-bootstrap';
function App() {
  const baseUrl=Pengaturan['baseurl'];
  return (    
    <Container>
        <Router>
          <Switch> 
            <Route exact path={baseUrl+'login'} component={Login} />
            <Route exact path={baseUrl} component={Login} />
            <Route path={baseUrl+'dashboard'}><Cekstatustoken Cmp={Dashboard} /></Route> 
            <Route path={baseUrl+'customer'}><Cekstatustoken Cmp={Customer} /></Route>
            <Route path={baseUrl+'router'}><Cekstatustoken Cmp={Routerboard} /> </Route>
            <Route path={baseUrl+'detailcustomer'}><Cekstatustoken Cmp={detailCustomer} /></Route>
            <Route path={baseUrl+'activeconnection'}><Cekstatustoken Cmp={ActiveConnection} /></Route>
            <Route path={baseUrl+'billing'}><Cekstatustoken Cmp={Billing} /></Route>
            <Route path={baseUrl+'pppsecret'}><Cekstatustoken Cmp={Pppsecret} /></Route>
            <Route path={baseUrl+'scheduler'}><Cekstatustoken Cmp={Scheduler} /></Route>
        </Switch>
        </Router>
      </Container>
  );
}

export default App;
